import { CACHE_FAVICON_URL, CACHE_LOGO_DATA, CACHE_LOGO_URL } from 'constants/localStorageKeys';
import { isImageDataUrl, isValidLogoEntry } from './isValidLogoEntry';

export const cacheLogoAssets = (logoUrl, faviconUrl) => {
    try {
        if (logoUrl) {
            localStorage.setItem(CACHE_LOGO_URL, logoUrl);
        }

        if (faviconUrl) {
            localStorage.setItem(CACHE_FAVICON_URL, faviconUrl);
        }
    } catch {
        // non-critical
    }

    // Async: fetch logo image and store as base64 data URL for instant rendering next visit
    if (logoUrl) {
        try {
            const existing = localStorage.getItem(CACHE_LOGO_DATA);
            if (existing) {
                const entry = JSON.parse(existing);
                if (isValidLogoEntry(entry, logoUrl)) {
                    return;
                }
            }
        } catch {
            // continue to re-cache
        }

        // Route through the nginx reverse proxy to avoid CORS restrictions.
        // /proxy/<host>/path → https://<host>/path (same-origin, no CORS)
        const proxyUrl = (() => {
            try {
                const u = new URL(logoUrl);

                return `/proxy/${u.host}${u.pathname}`;
            } catch {
                return logoUrl;
            }
        })();

        fetch(proxyUrl)
            .then((r) => {
                if (!r.ok) {
                    throw new Error(`Logo fetch failed: ${r.status}`);
                }

                return r.blob();
            })
            .then(
                (blob) =>
                    new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                    }),
            )
            .then((dataUrl) => {
                try {
                    if (!isImageDataUrl(dataUrl)) {
                        return;
                    }

                    localStorage.setItem(CACHE_LOGO_DATA, JSON.stringify({ url: logoUrl, dataUrl }));
                } catch {
                    // storage full
                }
            })
            .catch(() => {});
    }
};
